import React, { useState } from 'react';

export default function GroupsManager({ 
  canvas, 
  addGroup, 
  deleteGroup, 
  addLayerToGroup, 
  removeLayerFromGroup, 
  toggleGroupVisibility, 
  updateGroupName,
  selectedId,
  setSelectedId
}) {
  const [newGroupName, setNewGroupName] = useState('');
  const [expandedGroups, setExpandedGroups] = useState(new Set());

  const toggleGroupExpanded = (groupId) => {
    const newExpanded = new Set(expandedGroups);
    if (newExpanded.has(groupId)) {
      newExpanded.delete(groupId);
    } else {
      newExpanded.add(groupId);
    }
    setExpandedGroups(newExpanded);
  };

  const handleAddGroup = () => {
    if (newGroupName.trim()) {
      addGroup(newGroupName.trim());
      setNewGroupName('');
    }
  };

  const getGroupLayerCount = (group) => {
    return group.layers ? group.layers.length : 0;
  };

  const getGroupLayers = (group) => {
    if (!canvas.layers || !group.layers) return [];
    return canvas.layers.filter(layer => group.layers.includes(layer.id));
  };

  const getLayerIcon = (type) => {
    switch (type) {
      case "text": return "📝";
      case "image": return "🖼️";
      case "video": return "🎬";
      case "audio": return "🎵";
      case "gif": return "🎭";
      default: return "📄";
    }
  };

  const getLayerTitle = (layer) => {
    if (layer.type === "text") {
      return layer.content?.substring(0, 15) || "نص جديد";
    }
    if (layer.type === "image" || layer.type === "gif") {
      const fileName = layer.content?.split('/').pop() || "صورة";
      return fileName.length > 12 ? fileName.substring(0, 12) + "..." : fileName;
    }
    if (layer.type === "video") {
      const fileName = layer.content?.split('/').pop() || "فيديو";
      return fileName.length > 12 ? fileName.substring(0, 12) + "..." : fileName;
    }
    if (layer.type === "audio") {
      const fileName = layer.content?.split('/').pop() || "صوت";
      return fileName.length > 12 ? fileName.substring(0, 12) + "..." : fileName;
    }
    return "طبقة جديدة";
  };

  return (
    <div className="groups-manager" style={{
      background: 'var(--bg-secondary)',
      borderRadius: '15px',
      padding: '20px',
      boxShadow: '0 4px 15px var(--shadow-color)',
      border: '1px solid var(--border-color)',
      marginBottom: '20px'
    }}>
      <h3 style={{
        margin: '0 0 15px 0',
        color: 'var(--text-primary)',
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center'
      }}>
        📁 إدارة المجموعات (الشرائح المخصصة)
      </h3>

      {/* إضافة مجموعة جديدة */}
      <div style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '20px',
        alignItems: 'center'
      }}>
        <input
          type="text"
          value={newGroupName}
          onChange={(e) => setNewGroupName(e.target.value)}
          placeholder="اسم المجموعة الجديدة"
          style={{
            flex: 1,
            padding: '8px 12px',
            border: '1px solid var(--border-color)',
            borderRadius: '6px',
            fontSize: '14px',
            background: 'var(--bg-primary)',
            color: 'var(--text-primary)'
          }}
          onKeyPress={(e) => e.key === 'Enter' && handleAddGroup()}
        />
        <button
          onClick={handleAddGroup}
          disabled={!newGroupName.trim()}
          style={{
            background: 'var(--button-bg)',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer',
            opacity: newGroupName.trim() ? 1 : 0.6
          }}
        >
          ➕ إضافة مجموعة
        </button>
      </div>

      {/* قائمة المجموعات */}
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {(!canvas.groups || canvas.groups.length === 0) ? (
          <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: 'var(--text-secondary)',
            fontSize: '14px'
          }}>
            📁 لا توجد مجموعات بعد
            <br />
            <span style={{ fontSize: '12px' }}>أنشئ مجموعة جديدة لتنظيم الطبقات</span>
          </div>
        ) : (
          canvas.groups.map((group) => {
            const groupLayers = getGroupLayers(group);
            const isExpanded = expandedGroups.has(group.id);
            
            return (
              <div key={group.id} style={{
                border: '1px solid var(--border-color)',
                borderRadius: '8px',
                marginBottom: '10px',
                overflow: 'hidden'
              }}>
                {/* رأس المجموعة */}
                <div style={{
                  background: group.visible ? 'var(--success-color)' : 'var(--bg-card)',
                  padding: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  cursor: 'pointer'
                }}
                onClick={() => toggleGroupExpanded(group.id)}
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleGroupVisibility(group.id);
                    }}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      fontSize: '16px',
                      cursor: 'pointer',
                      color: group.visible ? '#fff' : 'var(--text-secondary)'
                    }}
                    title={group.visible ? 'إخفاء المجموعة' : 'إظهار المجموعة'}
                  >
                    {group.visible ? '👁️' : '🚫'}
                  </button>
                  
                  <span style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: group.visible ? '#fff' : 'var(--text-primary)',
                    flex: 1
                  }}>
                    {group.name} ({getGroupLayerCount(group)} طبقات)
                  </span>
                  
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleGroupExpanded(group.id);
                    }}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      fontSize: '16px',
                      cursor: 'pointer',
                      color: group.visible ? '#fff' : 'var(--text-secondary)',
                      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease'
                    }}
                  >
                    ▼
                  </button>
                  
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteGroup(group.id);
                    }}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      fontSize: '16px',
                      cursor: 'pointer',
                      color: group.visible ? '#fff' : 'var(--danger-color)'
                    }}
                    title="حذف المجموعة"
                  >
                    🗑️
                  </button>
                </div>

                {/* محتوى المجموعة */}
                {isExpanded && (
                  <div style={{
                    padding: '15px',
                    background: 'var(--bg-primary)',
                    borderTop: '1px solid var(--border-color)'
                  }}>
                    {/* تحرير اسم المجموعة */}
                    <div style={{ marginBottom: '15px' }}>
                      <input
                        type="text"
                        value={group.name}
                        onChange={(e) => updateGroupName(group.id, e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid var(--border-color)',
                          borderRadius: '4px',
                          fontSize: '14px',
                          background: 'var(--bg-secondary)',
                          color: 'var(--text-primary)'
                        }}
                        placeholder="اسم المجموعة"
                      />
                    </div>

                    {/* قائمة الطبقات في المجموعة */}
                    <div style={{ marginBottom: '15px' }}>
                      <h4 style={{
                        margin: '0 0 10px 0',
                        fontSize: '14px',
                        color: 'var(--text-primary)',
                        fontWeight: 'bold'
                      }}>
                        الطبقات في هذه المجموعة:
                      </h4>
                      
                      {groupLayers.length === 0 ? (
                        <div style={{
                          textAlign: 'center',
                          padding: '20px',
                          color: 'var(--text-secondary)',
                          fontSize: '12px',
                          background: 'var(--bg-secondary)',
                          borderRadius: '6px'
                        }}>
                          لا توجد طبقات في هذه المجموعة
                        </div>
                      ) : (
                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {groupLayers.map((layer) => (
                            <div key={layer.id} style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px',
                              background: layer.id === selectedId ? 'var(--bg-secondary)' : 'transparent',
                              borderRadius: '4px',
                              marginBottom: '4px',
                              border: layer.id === selectedId ? '1px solid var(--button-bg)' : '1px solid transparent'
                            }}>
                              <span style={{ fontSize: '14px' }}>{getLayerIcon(layer.type)}</span>
                              <span style={{
                                fontSize: '12px',
                                color: 'var(--text-primary)',
                                flex: 1
                              }}>
                                {getLayerTitle(layer)}
                              </span>
                              <button
                                onClick={() => setSelectedId(layer.id)}
                                style={{
                                  background: 'var(--button-bg)',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: '4px',
                                  padding: '4px 8px',
                                  fontSize: '10px',
                                  cursor: 'pointer'
                                }}
                              >
                                تحديد
                              </button>
                              <button
                                onClick={() => removeLayerFromGroup(layer.id, group.id)}
                                style={{
                                  background: 'var(--danger-color)',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: '4px',
                                  padding: '4px 8px',
                                  fontSize: '10px',
                                  cursor: 'pointer'
                                }}
                              >
                                إزالة
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* إضافة طبقة إلى المجموعة */}
                    <div>
                      <h4 style={{
                        margin: '0 0 10px 0',
                        fontSize: '14px',
                        color: 'var(--text-primary)',
                        fontWeight: 'bold'
                      }}>
                        إضافة طبقة إلى المجموعة:
                      </h4>
                      
                      <select
                        onChange={(e) => {
                          if (e.target.value) {
                            addLayerToGroup(e.target.value, group.id);
                            e.target.value = '';
                          }
                        }}
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid var(--border-color)',
                          borderRadius: '4px',
                          fontSize: '14px',
                          background: 'var(--bg-secondary)',
                          color: 'var(--text-primary)'
                        }}
                      >
                        <option value="">اختر طبقة لإضافتها...</option>
                        {canvas.layers
                          .filter(layer => !group.layers.includes(layer.id))
                          .map((layer) => (
                            <option key={layer.id} value={layer.id}>
                              {getLayerIcon(layer.type)} {getLayerTitle(layer)}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
} 